<template>
    <div>
        <headline>
            Zonen
            <template v-slot:more>
                <zone-create @created="load"></zone-create>
            </template>
        </headline>

        <loading v-show="loading"></loading>

        <div v-show="!loading">
            <tailwind-table class="mb-4"
                            :header="['Name', '# Schreibtische', '# Bookables','# Konferenzräume','']">
                <tr v-for="(group, i) in zones" :class="{'bg-white': i % 2}">
                    <td class="px-6 py-3">
                        <zone-item :item="group"></zone-item>
                    </td>
                    <td class="px-6 py-3">{{ group.desks_count }}</td>
                    <td class="px-6 py-3">{{ group.bookables_count || 0 }}</td>
                    <td class="px-6 py-3">{{ group.conference_rooms_count || 0 }}</td>
                    <td class="px-2 py-3 text-right">
                        <a :href="`/admin/pages/zones/${group.id}`">
                            <button-white>
                                Anzeigen
                            </button-white>
                        </a>
                    </td>
                </tr>
            </tailwind-table>
        </div>

    </div>
</template>

<script>
import Headline from "../components/UI/Headline";
import Loading from "../components/UI/Loading";
import TailwindTable from "../components/UI/TailwindTable";
import ButtonWhite from "../components/UI/ButtonWhite";
import ButtonPrimary from "../components/UI/ButtonPrimary";
import ZoneCreate from "../components/ZoneCreate";
import ZoneEdit from "../components/ZoneEdit";
import ZoneItem from "../components/ZoneItem.vue";

export default {
    name: "Zones",
    components: {
        ZoneItem,
        ZoneEdit, ZoneCreate, ButtonPrimary, ButtonWhite, TailwindTable, Loading, Headline
    },

    data: () => ({
        loading: false,
        zones: [],
    }),

    created() {
        this.load();
    },

    methods: {
        load() {
            this.loading = true;
            this.$http.get('/admin/zones')
                .then(result => {
                    this.zones = result.data.data;
                    this.loading = false;
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                    this.loading = false;
                })
        },
    }
}
</script>

<style scoped>

</style>
